<template>
  <div class="my-wrap finance-wrap">
    <div class="withdraw-frame withdraw-m-frame">
      <div class="my-withdraw-mobile-package withdraw-mobile">
        <div class="mobile-frame">
          <WithdrawTabNav
            :is-crypto-exchange="true"
            @toggle-mode="$emit('toggle-mode')"
          />

          <div class="slider-form withdraw-slider-form">
            <div class="slider">
              <form class="row-frame dep-form-frame gx-3 form-row-gap">
                <ExchangeFields view-type="mb" :page="self" />

                <AuthInput
                  :google-auth-enabled="google_auth_totp_status"
                  :withdrawal-pass.sync="postForm.withdrawal_pass"
                  :otp-code.sync="postForm.opt_code"
                  input-id="auth-input-mb"
                />

                <AgreeCheckbox
                  :agree.sync="agree"
                  :agree-tip="agreeTip"
                  checkbox-id="agree-mb"
                />
              </form>
            </div>
          </div>

          <div
            class="button-style-w100 btn-primary"
            :class="{ disabled: !checkInput() }"
            @click="sendTransfer"
          >
            {{ $t('Bao.send') }}
          </div>

          <div v-if="themeConfig.showWithdrawalDesc" @click="$router.push('/page/support')">
            <a class="help-deposit-n">
              <span class="icon-help">?</span>
              <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="pc-withdraw-layout">
        <WithdrawSidebar
          :is-crypto-exchange="true"
          @toggle-mode="$emit('toggle-mode')"
        />

        <div class="my-withdraw-frame">
          <div class="my-deposit my-d-box">
            <div class="slider-form withdraw-container">
              <div class="slider">
                <form class="row-frame dep-form-frame gx-3 form-row-gap">
                  <ExchangeFields view-type="pc" :page="self" />

                  <AuthInput
                    :google-auth-enabled="google_auth_totp_status"
                    :withdrawal-pass.sync="postForm.withdrawal_pass"
                    :otp-code.sync="postForm.opt_code"
                    input-id="auth-input-pc"
                  />

                  <AgreeCheckbox
                    :agree.sync="agree"
                    :agree-tip="agreeTip"
                    checkbox-id="agree-pc"
                  />

                  <div
                    class="button-style-w100 btn-primary"
                    :class="{ disabled: !checkInput() }"
                    @click="sendTransfer"
                  >
                    {{ $t('Bao.send') }}
                  </div>

                  <div v-if="themeConfig.showWithdrawalDesc" @click="$router.push('/page/support')">
                    <a class="help-deposit-n">
                      <span class="icon-help">?</span>
                      <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { walletTransferRate, walletTransfer } from '@/api/payment'
import { showNotice, setErrorMessage, detectMob } from '@/utils/tool'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

import WithdrawTabNav from '@/views/withdraw/WithdrawTabNav'
import WithdrawSidebar from '@/views/withdraw/WithdrawSidebar'
import AuthInput from '@/views/withdraw/AuthInput'
import AgreeCheckbox from '@/views/withdraw/AgreeCheckBox'
import ExchangeFields from '@/views/withdraw/WithdrawCryptoExchangeFields'

export default {
  name: 'WithdrawCryptoExchangeForm',
  inject: ['$validator'],
  components: {
    WithdrawTabNav,
    WithdrawSidebar,
    AuthInput,
    AgreeCheckbox,
    ExchangeFields
  },
  mixins: [themeMixin],
  props: {
    shared: {
      type: Object,
      required: true
    },
    common: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      withdrawType: 3,
      selectedExchangeTargetCoin: null,
      JPchainList: [
        { chain: 'USDT', supportMemo: false },
        { chain: 'XRP', supportMemo: false },
        { chain: 'LTC', supportMemo: false }
      ],
      transRateList: [],
      transferValue: 0,
      transferPostForm: {
        fromWallet: 'main',
        toWallet: '',
        amount: 0
      },
      exchangeInitialized: false,
      isOpenCurrency: false,
      isOpenCrypto: false,
      isOpenWallet: false
    }
  },
  computed: {
    ...mapGetters(['memberInfo', 'brandInfo', 'user', 'permissionInfo', 'app']),
    self() {
      return this
    },
    google_auth_totp_status() {
      return this.common.google_auth_totp_status
    },
    agree: {
      get() { return this.shared.agree },
      set(value) { this.shared.agree = value }
    },
    agreeTip() {
      return this.shared.agreeTip
    },
    postForm() {
      return this.shared.postForm
    },
    wallets() {
      return this.shared.wallets
    },
    mainWallet: {
      get() { return this.shared.mainWallet },
      set(value) { this.shared.mainWallet = value }
    },
    coinList() {
      return this.shared.coinList
    },
    exchangeTargetCoinList() {
      if (!this.selectedCoin) return this.coinList
      return this.coinList.filter(coin => coin.symbol !== this.selectedCoin.symbol)
    },
    paymentFeeData() {
      return this.shared.paymentFeeData
    },
    selectedWallet: {
      get() { return this.shared.selectedWallet },
      set(value) { this.shared.selectedWallet = value }
    },
    selectedWalletKey: {
      get() { return this.shared.selectedWalletKey },
      set(value) { this.shared.selectedWalletKey = value }
    },
    selectedCoin: {
      get() { return this.shared.selectedCoin },
      set(value) { this.shared.selectedCoin = value }
    },
    selectedChain: {
      get() { return this.shared.selectedChain },
      set(value) { this.shared.selectedChain = value }
    },
    chainList: {
      get() { return this.shared.chainList },
      set(value) { this.shared.chainList = value }
    },
    isCryptoSelect: {
      get() { return this.shared.isCryptoSelect },
      set(value) { this.shared.isCryptoSelect = value }
    },
    nonCryptoWallets() {
      return this.wallets.filter(w => w.key === 'main' || w.key === 'commission' || w.key === 'bonus')
    },
    withdrawalLimit() {
      const wallet = this.selectedCoin ? this.selectedCoin : this.selectedWallet
      if (wallet && wallet.withdrawal_limit && this.nonCryptoWallets.length > 0) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)
        return limit > 0 ? Math.floor(limit * 1e6) / 1e6 : 0
      }
      return 0
    },
    amount_limit() {
      const wallet = this.selectedWallet || this.getWalletByKey(this.selectedWalletKey) || this.mainWallet
      if (wallet && wallet.amount_limit && this.nonCryptoWallets.length > 0) {
        if (wallet.name === 'main' || wallet.name === 'commission' || wallet.name === 'bonus') {
          return parseInt(wallet.amount_limit.max)
        }
        return Math.floor(Number(wallet.amount_limit.max) * 1e6) / 1e6
      } else if (wallet && wallet.symbol) {
        const cryptoWallet = this.wallets.find(item => item.name === wallet.symbol)
        const limit = Math.floor(Number(cryptoWallet.amount_limit.max) * 1e6) / 1e6
        return limit > 0 ? limit : 0
      }
      return wallet && wallet.balance ? parseInt(wallet.balance) : 0
    },
    mainCurrencyLabel() {
      if (this.isTheme('theme_blue')) return 'UBD'
      if (this.isTheme('theme_purple')) return 'JRA'
      return this.mainWallet && this.mainWallet.currency ? this.mainWallet.currency : 'JPY'
    },
    exchangeAvailableAmount() {
      return this.formatExchangeNumber(this.exchangeActualTransferAmount)
    },
    exchangeActualTransferAmount() {
      const amount = Number(this.postForm.amount)
      const paymentFee = Number(this.exchangePaymentFee)
      if (!amount) return 0
      if (!paymentFee) return this.truncateExchangeNumber(amount)

      const amountAfterFee = amount - (amount * paymentFee / 100)
      return amountAfterFee > 0 ? this.truncateExchangeNumber(amountAfterFee) : 0
    },
    exchangeResultAmount() {
      return this.selectedExchangeTargetCoin ? this.formatExchangeNumber(this.transferValue) : 0
    },
    exchangeReceiveAmountText() {
      if (!this.selectedExchangeTargetCoin) return '0'
      return `${this.exchangeResultAmount} ${this.selectedExchangeTargetCoin.symbol}`
    },
    exchangeSourceCurrency() {
      if (this.selectedCoin) return this.selectedCoin.symbol
      return this.mainWallet?.currency || this.mainCurrencyLabel
    },
    exchangeRateText() {
      if (!this.selectedExchangeTargetCoin) return '-'
      const rate = this.calculateExchangeRate(1)
      if (!rate) return '-'
      return `1 ${this.exchangeSourceCurrency} ≈ ${this.formatExchangeNumber(rate)} ${this.selectedExchangeTargetCoin.symbol}`
    },
    exchangePaymentFee() {
      const matched = this.getExchangeRateInfo()
      if (!matched) return ''
      if (matched.fee_percent !== undefined && matched.fee_percent !== null) {
        return this.formatFeePercent(matched.fee_percent)
      }
      const matchedRateInfo = matched.rateInfo?.find(item => item.currency === this.exchangeSourceCurrency)
      const rateInfoWithFee = matchedRateInfo || matched.rateInfo?.find(item => item.fee_percent !== undefined)
      return this.formatFeePercent(rateInfoWithFee?.fee_percent)
    },
    hasExchangePaymentFee() {
      return Number(this.exchangePaymentFee) !== 0
    },
    canSwapExchangeCoins() {
      return !!this.selectedCoin && !!this.selectedExchangeTargetCoin
    }
  },
  watch: {
    wallets: {
      handler(wallets) {
        if (wallets.length === 0 || this.exchangeInitialized) return
        this.initExchangeMode()
      },
      immediate: true
    },
    selectedCoin: {
      handler(newCoin) {
        if (newCoin && newCoin.networks) {
          this.chainList = Object.values(newCoin.networks).map(network => ({
            chain: network.chain,
            supportMemo: network.supportMemo
          }))
          this.selectedChain = this.chainList[0] || null
          this.selectedWallet = newCoin
          this.postForm.wallet_type = newCoin.symbol
        }
      },
      immediate: true
    },
    amount_limit(newLimit) {
      if (Number(newLimit) <= 0) return
      if (this.postForm.amount === '' || Number(this.postForm.amount) === 0) {
        this.setExchangeMaxAmount()
      }
    }
  },
  methods: {
    getWalletImagePath(...args) {
      return this.common.getWalletImagePath(...args)
    },
    getWalletByKey(key) {
      return this.common.getWalletByKey(key)
    },
    getWalletName(key) {
      const map = {
        main: this.$t('Bao.main_wallet'),
        commission: this.$t('Bao.commission_wallet'),
        bonus: this.$t('Bao.wallet_type_bonus')
      }
      return map[key] || key
    },
    initExchangeMode() {
      this.isCryptoSelect = false
      this.selectedWallet = this.getWalletByKey('main')
      this.selectedWalletKey = 'main'
      this.postForm.wallet_type = 'main'
      this.chainList = this.JPchainList
      this.selectedChain = null
      this.selectedExchangeTargetCoin = null
      this.transferPostForm.fromWallet = 'main'
      this.transferPostForm.toWallet = ''
      this.selectedCoin = null
      this.setExchangeMaxAmount()
      this.loadTransferRate()
      this.exchangeInitialized = true
    },
    onSelectCrypto(coin) {
      this.withdrawType = 3
      this.selectCrypto(coin)
      this.isOpenCurrency = false
      this.transferPostForm.fromWallet = coin.symbol
      this.$nextTick(() => {
        this.setExchangeMaxAmount()
        this.getTransferValue()
      })
    },
    selectExchangeTargetCrypto(coin) {
      this.selectedExchangeTargetCoin = coin
      this.transferPostForm.toWallet = coin.symbol
      this.selectedChain = { chain: coin.symbol, supportMemo: false }
      this.isOpenCrypto = false
      this.updateSelectedCoinPaymentFee()
      this.getTransferValue()
    },
    swapExchangeCoins() {
      if (!this.canSwapExchangeCoins) return

      const currentSourceCoin = this.selectedCoin
      const currentTargetCoin = this.selectedExchangeTargetCoin

      this.selectedExchangeTargetCoin = currentSourceCoin
      this.selectCrypto(currentTargetCoin)
      this.transferPostForm.fromWallet = currentTargetCoin.symbol
      this.transferPostForm.toWallet = currentSourceCoin.symbol
      this.selectedChain = { chain: currentSourceCoin.symbol, supportMemo: false }
      this.isOpenCurrency = false
      this.isOpenCrypto = false

      this.$nextTick(() => {
        this.setExchangeMaxAmount()
        this.getTransferValue()
      })
    },
    selectNonCryptoWallet(wallet) {
      this.isCryptoSelect = false
      this.selectedCoin = null
      this.chainList = this.JPchainList
      this.selectedChain = this.chainList[0] || null
      this.selectedWalletKey = wallet.key
      this.selectedWallet = this.getWalletByKey(wallet.key)
      this.postForm.wallet_type = wallet.key
      this.transferPostForm.fromWallet = wallet.key
      this.transferPostForm.toWallet = this.selectedExchangeTargetCoin ? this.selectedExchangeTargetCoin.symbol : ''
      this.isOpenCurrency = false
      this.isOpenWallet = false
      if (this.transRateList.length === 0) this.loadTransferRate()
      this.setExchangeMaxAmount()
      this.getTransferValue()
    },
    selectCrypto(coin) {
      this.selectedCoin = coin
      this.isCryptoSelect = true
      if (this.selectedExchangeTargetCoin?.symbol === coin.symbol) {
        this.selectedExchangeTargetCoin = null
        this.transferPostForm.toWallet = ''
        this.selectedChain = null
      }
      this.updateSelectedCoinPaymentFee()
    },
    getExchangeRateInfo() {
      if (!this.selectedExchangeTargetCoin) return null
      return this.transRateList.find(item => {
        if (item.fromCurrency !== this.exchangeSourceCurrency) return false
        if (item.toCurrency !== this.selectedExchangeTargetCoin.symbol) return false
        if (!this.selectedCoin && item.fromWallet !== this.selectedWalletKey) return false
        return true
      })
    },
    calculateExchangeRate(amount) {
      const matched = this.getExchangeRateInfo()
      if (!matched?.rateInfo) return 0

      let result = Number(amount)
      matched.rateInfo
        .filter(rateItem => rateItem.action === 'multiply')
        .forEach((rateItem) => {
          const rate = Number(rateItem.rate)
          if (rate) result *= rate
        })

      matched.rateInfo
        .filter(rateItem => rateItem.action === 'divide')
        .forEach((rateItem) => {
          const rate = Number(rateItem.rate)
          if (rate) result /= rate
        })

      return result
    },
    updateSelectedCoinPaymentFee() {
      if (!this.selectedCoin) return
      this.selectedCoin.payment_fee = this.exchangePaymentFee
    },
    truncateExchangeNumber(value) {
      if (!value || isNaN(value)) return 0
      return Math.trunc(value * 1e12) / 1e12
    },
    formatExchangeNumber(value) {
      const numberValue = Number(value)
      if (!numberValue || isNaN(numberValue)) return 0

      const fixedValue = numberValue.toFixed(12)
      if (Math.abs(numberValue) < 0.000001) return fixedValue

      return fixedValue.replace(/\.?0+$/, '')
    },
    formatFeePercent(value) {
      if (value === null || value === undefined || value === '') return ''
      return String(value).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
    },
    setExchangeMaxAmount() {
      const maxAmount = Number(this.amount_limit)
      this.postForm.amount = maxAmount > 0 ? this.amount_limit : 0
      this.getTransferValue()
    },
    onExchangeAmountInput(event) {
      const maxAmount = Number(this.amount_limit)
      const sanitizedValue = event.target.value.replace(/[^\d.]/g, '')
      const parts = sanitizedValue.split('.')
      const inputValue = parts.length > 1 ? `${parts.shift()}.${parts.join('')}` : sanitizedValue
      const amount = Number(inputValue)

      if (inputValue === '') {
        this.postForm.amount = ''
      } else if (maxAmount <= 0) {
        this.postForm.amount = 0
      } else if (isNaN(amount)) {
        this.postForm.amount = ''
      } else if (amount > maxAmount) {
        this.postForm.amount = this.amount_limit
      } else {
        this.postForm.amount = inputValue
      }

      event.target.value = this.postForm.amount
      this.getTransferValue()
    },
    checkInput() {
      const amountValid = this.postForm.amount !== '' && !isNaN(this.postForm.amount)
      const hasWallet = !!this.selectedWallet
      const passedAuth = this.google_auth_totp_status
        ? !!this.postForm.opt_code
        : !!this.postForm.withdrawal_pass

      this.getTransferValue()
      return amountValid && hasWallet && !!this.selectedExchangeTargetCoin && this.agree && passedAuth
    },
    getTransferValue() {
      if (!this.selectedExchangeTargetCoin) {
        this.transferValue = 0
        return
      }
      this.transferPostForm.amount = this.postForm.amount
      this.transferValue = this.calculateExchangeRate(this.exchangeActualTransferAmount)
    },
    sendTransfer() {
      const transferPostForm = {
        ...this.transferPostForm,
        withdrawal_pass: this.postForm.withdrawal_pass,
        opt_code: this.postForm.opt_code
      }

      walletTransfer(transferPostForm)
        .then((response) => {
          const code = Math.abs(response.data.data.code)
          const key = code === 1 ? 'Bao.withdrawal_transfer_success' : `Bao.withdrawal_error_${code}`
          showNotice(this.$t(key), () => {
            if (code === 1) this.$router.push({ path: '/user/transaction-history?type=other' })
          })
        })
        .catch((error) => setErrorMessage(error.response, this.errors))
    },
    loadTransferRate() {
      return walletTransferRate().then((response) => {
        this.transRateList = response.data.data.rate
        this.updateSelectedCoinPaymentFee()
        if (this.selectedExchangeTargetCoin) this.getTransferValue()
      }).catch((error) => setErrorMessage(error.response, this.errors))
    },
    isMobile() {
      return detectMob()
    }
  }
}
</script>

<style scoped>
.my-wrap .content {
  background-color: var(--bg-primary) !important;
  border: none !important;
  padding: 40px !important;
}
.withdraw-mode-form {
  display: contents;
}
</style>
